import clsx from 'clsx'
import { Tag, UserRound } from 'lucide-react'
import { TailSpin } from 'react-loading-icons'

import { type ComboboxFilterOption } from '../../reusable/table/ComboboxMultiSelectFilter'

type NAVAssignmentDropdownProps<T> = {
  noSelectionText?: string
  pluralIdentifier?: string
  selectedValues: T[]
  options: ComboboxFilterOption<T>[]
  open?: boolean
  isPending: boolean
  type: 'assignee' | 'tag'
}

const NAVAssignmentDropdown = <T,>({
  selectedValues,
  noSelectionText = 'No tags...',
  pluralIdentifier = 'tags',
  options,
  open,
  isPending,
  type,
}: NAVAssignmentDropdownProps<T>) => {
  const getSelectedOptionValue = () => {
    if (selectedValues.length === 0) {
      return noSelectionText
    }

    if (selectedValues.length === 1) {
      return options.find((option) => option.value === selectedValues[0])?.label
    }

    return `${selectedValues.length} ${pluralIdentifier}`
  }

  return (
    <div
      role='combobox'
      aria-expanded={open}
      style={{ width: '100px', maxHeight: '30px' }}
      className={clsx({
        'border rounded-md flex items-center justify-between p-1 text-xs': true,
        'text-thatch-purple': selectedValues.length > 0,
        'text-ds-text-secondary': selectedValues.length === 0,
      })}
    >
      {isPending
        ? (
          <TailSpin fill='#9C3BFF' stroke='#9C3BFF' height='15px' />
          )
        : (
          <span className='truncate'>{getSelectedOptionValue()}</span>
          )}
      {type === 'tag'
        ? (
          <Tag className='opacity-50' size={12} style={{ flexShrink: '0' }} />
          )
        : (
          <UserRound
            className='opacity-50'
            size={12}
            style={{ flexShrink: '0' }}
          />
          )}
    </div>
  )
}

export default NAVAssignmentDropdown
